module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "abs-pa"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.paName
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.$abs.row.pa),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "pa", $$v)
      },
      expression: "$abs.row.pa"
    }
  }, _vm._l((_vm.$teras.autori), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.cognome + ' ' + item.nome,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.email,
      "prop": "paemail"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.$abs.row.paemail),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "paemail", $$v)
      },
      expression: "$abs.row.paemail"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col s6"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.cellulare,
      "prop": "pacellulare"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.$abs.row.pacellulare),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "pacellulare", $$v)
      },
      expression: "$abs.row.pacellulare"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.$teras.evento.pacodicefiscale == 1) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.codicefiscale,
      "prop": "pacodicefiscale"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.$abs.row.pacodicefiscale),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "pacodicefiscale", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "$abs.row.pacodicefiscale"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.panato == 1) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.annonascita,
      "prop": "panato"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.$abs.row.panato),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "panato", $$v)
      },
      expression: "$abs.row.panato"
    }
  }, _vm._l((_vm.annonascita), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.pacategoriaprofessionale == 1) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.categoriaprofessionale,
      "prop": "pacategoriaprofessionale"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.$abs.row.pacategoriaprofessionale),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "pacategoriaprofessionale", $$v)
      },
      expression: "$abs.row.pacategoriaprofessionale"
    }
  }, _vm._l((_vm.$teras.categoriaprofessionale), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item['nome_' + _vm.$teras.language],
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.paregionelavoro == 1) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.regionelavoro,
      "prop": "paregionelavoro"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.$abs.row.paregionelavoro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "paregionelavoro", $$v)
      },
      expression: "$abs.row.paregionelavoro"
    }
  }, _vm._l((_vm.$teras.regione), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item['nome_' + _vm.$teras.language],
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.panazionelavoro == 1) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.nazionelavoro,
      "prop": "panazionelavoro"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.$abs.row.panazionelavoro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "panazionelavoro", $$v)
      },
      expression: "$abs.row.panazionelavoro"
    }
  }, _vm._l((_vm.$teras.nazione), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item['nome_' + _vm.$teras.language],
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.paassociazione != '') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.socio,
      "prop": "paassociazione"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.$abs.row.paassociazione),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "paassociazione", $$v)
      },
      expression: "$abs.row.paassociazione"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Non socio",
      "value": -1
    }
  }), _vm._v(" "), _vm._l((_vm.$teras.associazioni), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item['nome_' + _vm.$teras.language],
        "value": item.id
      }
    })
  })], 2)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b7a9150"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Abs-primoautore.vue
// module id = 604
// module chunks = 2